import React, { useState } from "react";
import { Phone, Mail, Send, Check } from "lucide-react";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: "", email: "", phone: "", company: "", message: "" });
    }, 1000);
  };

  return (
    <section
      id="contact"
      className="section-surface"
      style={{
        paddingTop: "90px",
        paddingBottom: "90px",
      }}
    >
      <div className="container">
        <div className="row align-items-stretch">
          {/* Left Column: Direct Details */}
          <div className="col-lg-5 mb-5 mb-lg-0">
            <div
              className="card-clean"
              style={{
                height: "100%",
                borderRadius: "20px",
                padding: "36px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <span className="badge-label mb-2">Direct Contact</span>

                <h3
                  style={{
                    fontFamily: "var(--font-display)",
                    fontSize: "1.85rem",
                    fontWeight: 700,
                    color: "#0f172a",
                    marginTop: "8px",
                    marginBottom: "12px",
                  }}
                >
                  Let's talk.
                </h3>

                <p
                  style={{
                    color: "#64748b",
                    fontSize: "0.95rem",
                    lineHeight: 1.6,
                    marginBottom: "32px",
                  }}
                >
                  Have questions about EMIBOOK, bulk subscriptions, or getting your
                  existing loan book set up? Reach out to our team.
                </p>

                <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        background: "rgba(37, 99, 235, 0.08)",
                        color: "#2563eb",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Phone size={18} />
                    </div>
                    <div>
                      <div style={{ fontSize: "0.75rem", color: "#64748b", textTransform: "uppercase", fontWeight: 700 }}>
                        Call Us Directly
                      </div>
                      <a
                        href="tel:9036770772"
                        style={{ color: "#0f172a", fontSize: "1rem", fontWeight: 700, textDecoration: "none" }}
                      >
                        +91 9036770772
                      </a>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        background: "rgba(124, 58, 237, 0.08)",
                        color: "#7c3aed",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Mail size={18} />
                    </div>
                    <div>
                      <div style={{ fontSize: "0.75rem", color: "#64748b", textTransform: "uppercase", fontWeight: 700 }}>
                        Email Inquiries
                      </div>
                      <a
                        href="mailto:support@emibook.in"
                        style={{ color: "#0f172a", fontSize: "1rem", fontWeight: 700, textDecoration: "none" }}
                      >
                        support@emibook.in
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  paddingTop: "20px",
                  marginTop: "28px",
                  borderTop: "1px solid #f1f5f9",
                  fontSize: "0.82rem",
                  color: "#64748b",
                }}
              >
                Managed by <strong>S R R Enterprise</strong>
              </div>
            </div>
          </div>

          {/* Right Column: Clean Inquiry Form */}
          <div className="col-lg-7">
            <div
              className="card-clean"
              style={{
                height: "100%",
                borderRadius: "20px",
                padding: "36px",
              }}
            >
              <h3
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "1.35rem",
                  fontWeight: 700,
                  color: "#0f172a",
                  marginBottom: "6px",
                }}
              >
                Send Us a Message
              </h3>
              <p style={{ color: "#64748b", fontSize: "0.9rem", marginBottom: "24px" }}>
                Fill out the form below and we will respond promptly.
              </p>

              {submitted ? (
                <div
                  style={{
                    padding: "24px",
                    borderRadius: "12px",
                    background: "#ecfdf5",
                    border: "1px solid #a7f3d0",
                    color: "#065f46",
                    textAlign: "center",
                  }}
                >
                  <Check size={28} color="#059669" style={{ margin: "0 auto 8px auto" }} />
                  <h4 style={{ fontWeight: 700, color: "#065f46", marginBottom: "4px", fontSize: "1.05rem" }}>
                    Thank You for Reaching Out
                  </h4>
                  <p style={{ fontSize: "0.9rem", margin: 0 }}>
                    We have received your message and will respond shortly.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label style={{ fontSize: "0.82rem", fontWeight: 600, color: "#334155", marginBottom: "6px" }}>
                        Full Name *
                      </label>
                      <input
                        type="text"
                        required
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        placeholder="Rahul Sharma"
                        style={{
                          width: "100%",
                          padding: "10px 14px",
                          borderRadius: "10px",
                          border: "1px solid #cbd5e1",
                          fontSize: "0.9rem",
                          background: "#ffffff",
                          outline: "none",
                        }}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label style={{ fontSize: "0.82rem", fontWeight: 600, color: "#334155", marginBottom: "6px" }}>
                        Email Address *
                      </label>
                      <input
                        type="email"
                        required
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        placeholder="you@company.com"
                        style={{
                          width: "100%",
                          padding: "10px 14px",
                          borderRadius: "10px",
                          border: "1px solid #cbd5e1",
                          fontSize: "0.9rem",
                          background: "#ffffff",
                          outline: "none",
                        }}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label style={{ fontSize: "0.82rem", fontWeight: 600, color: "#334155", marginBottom: "6px" }}>
                        Phone Number *
                      </label>
                      <input
                        type="tel"
                        required
                        value={formData.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        placeholder="+91 98765 43210"
                        style={{
                          width: "100%",
                          padding: "10px 14px",
                          borderRadius: "10px",
                          border: "1px solid #cbd5e1",
                          fontSize: "0.9rem",
                          background: "#ffffff",
                          outline: "none",
                        }}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label style={{ fontSize: "0.82rem", fontWeight: 600, color: "#334155", marginBottom: "6px" }}>
                        Business / Store Name
                      </label>
                      <input
                        type="text"
                        value={formData.company}
                        onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                        placeholder="Store or Company"
                        style={{
                          width: "100%",
                          padding: "10px 14px",
                          borderRadius: "10px",
                          border: "1px solid #cbd5e1",
                          fontSize: "0.9rem",
                          background: "#ffffff",
                          outline: "none",
                        }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label style={{ fontSize: "0.82rem", fontWeight: 600, color: "#334155", marginBottom: "6px" }}>
                      Message *
                    </label>
                    <textarea
                      rows="3"
                      required
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      placeholder="How can we help your business?"
                      style={{
                        width: "100%",
                        padding: "10px 14px",
                        borderRadius: "10px",
                        border: "1px solid #cbd5e1",
                        fontSize: "0.9rem",
                        background: "#ffffff",
                        outline: "none",
                      }}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn-saas-primary"
                    style={{
                      width: "100%",
                      height: "44px",
                      borderRadius: "10px",
                    }}
                  >
                    Send Message <Send size={15} />
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
